// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__3X-jO","footer":"ModalUpdate_footer__p5wtN"};